<template>
  <div>
    <Loading v-if="initialLoad"></Loading>
    <Layout v-else>
      <div class="pt-4">
        <h3 style="font-weight: bold">POS Transactions</h3>
      </div>
      <section class="pt-5">
        <Overview class="overview">
          <h4 slot="heading">
            <span>Overview</span>
            <span class="float-right">
              <span v-if="startDate">
                {{ startDate | moment("dddd, MMMM Do YYYY") }} -
                {{ endDate | moment("dddd, MMMM Do YYYY") }}
              </span>
              <span v-else>{{ today | moment("dddd, MMMM Do YYYY") }}</span>
            </span>
          </h4>
          <p slot="card-1-title">Total POS Transaction Value</p>
          <h3 slot="card-1-val">
            ₦<ICountUp
              :delay="delay"
              :endVal="totalPosSumValue"
              :options="options"
              @ready="getTotalPosSumValue"
            />
          </h3>
          <!-- <span slot="card-1-percent">+95%</span>
          <span slot="from" class="grey-color pl_4">from last month</span> -->

          <p slot="card-2-title">Total POS Transaction Volume</p>
          <h3 slot="card-2-val">
            <ICountUp
              :delay="delay"
              :endVal="totalPosVolume"
              :options="options"
              @ready="getTotalPosVolume"
            />
          </h3>
          <!-- <span slot="card-2-percent">+19%</span> -->

          <p slot="card-4-earnings">Total Earnings</p>
          <h3 slot="card-4-val">Coming Soon</h3>
          <!-- <span slot="card-4-percent"></span> -->
          <span></span>
        </Overview>
      </section>
      <section class="pt-5">
        <TransactionsList>
          <b-form-input
            slot="search-bar"
            type="search"
            placeholder="Search shown entries"
            v-model="filter"
            trim
          />
          <b-button slot="search-btn" class="d-none" variant="primary"
            >Search</b-button
          >
          <span slot="entries-no">
            {{ entriesShown }} of {{ totalEntries }} entries
          </span>
          <b-form-datepicker
            slot="start-date"
            id="pos-start-date"
            placeholder="Start date"
            locale="en"
            class="filter-date"
            :max="today"
            @input="enableEndDate"
            v-model="startDate"
          ></b-form-datepicker>
          <b-form-datepicker
            slot="end-date"
            id="pos-end-date"
            placeholder="End date"
            locale="en"
            class="filter-date"
            :disabled="disabled"
            :min="startDate"
            :max="today"
            @input="enableApply"
            v-model="endDate"
          ></b-form-datepicker>
          <b-form-input
            slot="start-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="end-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="status-input"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-checkbox
            slot="save-default"
            class="save-filter"
            id="save-filter"
          >
            Save as default filter
          </b-form-checkbox>
          <b-button
            slot="clear-btn"
            class="btn-alt filter-btn"
            block
            variant="primary"
            @click="clearFilter"
          >
            Clear
          </b-button>
          <b-button
            slot="apply-btn"
            slot-scope="{ closeModal }"
            class="filter-btn"
            block
            variant="primary"
            :disabled="disabledApply"
            @click="
              closeModal();
              applyFilter();
            "
          >
            Apply
          </b-button>
          <b-table
            slot="table"
            hover
            sticky-header
            :busy="isBusy"
            :filter="filter"
            :per-page="perPage"
            :items="posTableData"
            :empty-filtered-html="emptyImg"
            show-empty
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-1"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
          <b-pagination-nav
            slot="pagination"
            class="d-flex justify-content-end"
            :class="{ 'rc-pagination': rcPagination }"
            :link-gen="linkGen"
            :number-of-pages="totalPages"
            :disabled="isBusy"
            prev-text="Previous"
            next-text="Next"
            use-router
            @change="removeClass"
          ></b-pagination-nav>
        </TransactionsList>
      </section>
    </Layout>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "@/components/Loading.vue";
import Layout from "@/components/Layout.vue";
import TransactionsList from "@/components/TransactionsList.vue";
import Overview from "@/components/Overview.vue";
import ICountUp from "vue-countup-v2";
import { mapState, mapActions } from "vuex";

export default {
  name: "PosTransactions",
  components: {
    Loading,
    Layout,
    Overview,
    ICountUp,
    TransactionsList,
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      filter: "",
      page: "",
      perPage: 20,
      disabled: true,
      disabledApply: true,
      rcPagination: true,
      today: moment(Date.now()).format("YYYY-MM-DD"),
    };
  },
  computed: {
    ...mapState({
      initialLoad: (state) => state.pos.initialLoad,
      refresh: (state) => state.pos.refresh,
      delay: (state) => state.user.delay,
      options: (state) => state.user.options,
      isBusy: (state) => state.pos.busy,
      emptyImg: (state) => state.user.empty,

      totalPosSumValue: (state) => state.pos.posOverview.totalSumValue,
      totalPosVolume: (state) => state.pos.posOverview.totalCount,
      // totalPosEarnings: (state) => state.pos.posOverview.earnings,
      totalPages: (state) => state.pos.posTransactions.meta.last_page,
      totalEntries: (state) => state.pos.posTransactions.meta.total,
      entriesShown: (state) =>
        state.pos.posTransactions.meta.to !== null
          ? state.pos.posTransactions.meta.to
          : 0,
      posTableData: (state) => {
        if (state.pos.posTransactions.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.pos.posTransactions.data;
        }
      },
    }),
  },
  methods: {
    ...mapActions({
      posTransactions: "pos/getPosTransactions",
      posOverview: "pos/getPosOverview",
    }),
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    getTotalPosSumValue(instance) {
      const that = this;
      instance.update(that.totalPosSumValue);
    },
    getTotalPosVolume(instance) {
      const that = this;
      instance.update(that.totalPosVolume);
    },
    // getTotalPosEarnings(instance) {
    //   const that = this;
    //   instance.update(that.totalPosEarnings);
    // },
    getTodayData() {
      this.posTransactions({
        startDate: this.today,
        endDate: this.today,
        page: this.page ? this.page : 1,
      });
      this.posOverview({
        startDate: this.today,
        endDate: this.today,
      });
    },
    refreshDataOrGotoPage() {
      if (this.startDate.length < 1 && this.endDate.length < 1) {
        this.getTodayData();
      } else if (this.startDate.length > 1 && this.endDate.length > 1) {
        this.applyFilter();
      }
    },
    applyFilter(page) {
      this.posTransactions({
        startDate: this.startDate,
        endDate: this.endDate,
        page: page ? page : 1,
      });
      this.posOverview({
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
    clearFilter() {
      (this.startDate = ""), (this.endDate = "");
    },
    enableEndDate() {
      this.disabled = false;
    },
    enableApply() {
      this.disabledApply = false;
    },
    removeClass() {
      this.rcPagination = false;
    },
  },
  watch: {
    refresh() {
      if (this.refresh === true) {
        console.log("Refresh POS");
        this.refreshDataOrGotoPage();
      }
    },
    "$route.query": {
      handler(query) {
        if (query.page) {
          this.page = query.page;
          this.refreshDataOrGotoPage();
        }
      },
      deep: true,
    },
  },
  created() {
    document.title = "POS Transactions | ReadyCash Aggregator Portal";
    this.getTodayData();
  },
};
</script>

<style></style>
